import { useSidebar } from "units/dashboard/context/SidebarProvider";
import { useSelector } from "react-redux";
import config from "../../../config.js";
import { Menu, Sparkles } from "lucide-react";

const ClientHeader = ({ username }) => {
  const BASE_URL = config.cdnUrl;
  const { toggleSidebar, isMobile } = useSidebar();
  const logo = JSON.parse(localStorage.getItem("logo") || "null");
  const name = useSelector((state) => state?.botInfo?.name);

  return (
    <div className="flex items-center justify-between w-full bg-[#1B4748] shadow-lg shadow-[#1B4748]/20">
      {/* بخش لوگو و برند */}
      <div className="topbar-brand flex items-center">
        <div className="flex items-center h-[70px] border-r border-white/10 mr-0 ml-0 flex-shrink-0 min-w-0 max-w-full px-4">
          <a href="#" className="flex items-center font-bold text-xl flex-grow gap-3">
            <img
              src={logo ? `${BASE_URL}${logo}` : "/defaultLogo.png"}
              className="inline-block h-[45px] w-[45px] object-cover rounded-xl ring-2 ring-white/10"
              alt=""
            />
            <div className="hidden sm:flex flex-col items-start">
              <span className="text-white font-bold text-base leading-tight">
                {name?.trim() || username || ""}
              </span>
              <span className="text-[10px] text-white/50 flex items-center gap-1">
                <Sparkles className="w-3 h-3 text-[#aadec5]" />
                بات هوشمند
              </span>
            </div>
          </a>
        </div>
      </div>

      {/* بخش سمت راست - فقط دکمه‌ی باز کردن سایدبار (فقط موبایل) */}
      {isMobile && (
        <div className="flex items-center px-4">
          <button
            type="button"
            onClick={toggleSidebar}
            aria-label="باز کردن منو"
            className="
              w-10 h-10 flex items-center justify-center rounded-xl
              text-white
              hover:bg-white/10
              active:scale-95
              transition-all duration-200
            "
          >
            <Menu className="w-6 h-6" />
          </button>
        </div>
      )}
    </div>
  );
};

export default ClientHeader;